// Entry da PDP do redesign. Precisa ficar direto em javascripts/pages porque
// o build não reconhece entry points em subpastas.
// Quantidade e variantes: ProductPurchase (main-redesign.js).

import customSelect from './product/customSelect';
import { updatePriceBlock } from '../components/utilities';
import setStickyBuy from '../redesign/product/stickyBuy';
import { initRadarCharts } from '../redesign/components/radarChart';
import initHeaderCarousel from '../redesign/product/headerCarousel';

const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const animateSensorySliders = (root) => {
  const scope = root || document;
  const sliders = scope.querySelectorAll('.rd-pdp-sensory .rd-slider[data-slider-value]');

  if (!sliders.length) return;

  if (prefersReducedMotion()) {
    sliders.forEach((slider) => slider.classList.add('is-animated'));
    return;
  }

  // Stagger leve: cada thumb sobe na sequência
  sliders.forEach((slider, index) => {
    window.setTimeout(() => {
      slider.classList.add('is-animated');
    }, 80 + index * 140);
  });
};

const revealHero = () => {
  const heroReveals = document.querySelectorAll('.rd-pdp-hero [data-rd-pdp-reveal]');
  heroReveals.forEach((el) => el.classList.add('is-visible'));
};

const observeSectionReveals = () => {
  const targets = document.querySelectorAll(
    '.rd-pdp-specs__text[data-rd-pdp-reveal], .rd-pdp-sensory__content[data-rd-pdp-reveal], .rd-pdp-radar[data-rd-pdp-reveal]'
  );

  if (!targets.length) return;

  if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-visible'));
    animateSensorySliders();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');

        if (entry.target.classList.contains('rd-pdp-sensory__content')) {
          animateSensorySliders(entry.target);
        }

        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.2 }
  );

  targets.forEach((el) => observer.observe(el));
};

const setPdpMotion = () => {
  if (prefersReducedMotion()) {
    document.querySelectorAll('[data-rd-pdp-reveal]').forEach((el) => {
      el.classList.add('is-visible');
    });
    return;
  }

  // Próximo frame para o browser aplicar o estado inicial (opacity 0).
  requestAnimationFrame(() => {
    revealHero();
  });
  observeSectionReveals();
};

const ProductRedesign = {
  init: function () {
    const mainProductForm = document.querySelector(`[data-product-id="${window.mainProduct}"]`);

    if (mainProductForm) {
      customSelect.init(mainProductForm);
    }

    updatePriceBlock();
    setStickyBuy();
    setPdpMotion();
    initHeaderCarousel();
    initRadarCharts();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  ProductRedesign.init();
});
